import { useIsMobileBreakpoint } from '@/hooks/useIsBreakpoint';
import {
  forwardRef,
  Icon,
  Tab as ChakraTab,
  type TabProps,
  type Icons,
} from '@/ui';

type Props = TabProps & {
  icon: keyof typeof Icons;
};

// Segment inside the FilterTabList rail. Chakra's Tab isn't a Button, so the
// ahTab button variant styles are replicated inline.
export const FilterTab = forwardRef(
  ({ icon, children, ...props }: Props, ref) => {
    const isMobileBreakpoint = useIsMobileBreakpoint();

    return (
      <ChakraTab
        {...props}
        _hover={{ bg: 'rgba(0,0,0,0.04)', color: 'ink.strong' }}
        alignItems="center"
        borderBottom="none"
        borderRadius="ah-md"
        color="ink.soft"
        display="flex"
        fontSize="ah-control"
        fontWeight={500}
        gap="2"
        lineHeight="normal"
        py="1.5"
        ref={ref}
        transition="background 0.14s, color 0.14s"
        _focusVisible={{
          boxShadow: 'none',
          outline: '2px solid',
          outlineColor: 'ink.muted',
          outlineOffset: '1px',
        }}
        _selected={{
          bg: 'ink.strong',
          color: 'white',
          fontWeight: 600,
          boxShadow: '0 1px 3px rgba(0,0,0,0.2)',
        }}
      >
        {!isMobileBreakpoint && <Icon icon={icon} size={4} />}
        {children}
      </ChakraTab>
    );
  }
);
